"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DOMException = require("domexception/webidl2js-wrapper");
var StorageEvent = require("../generated/StorageEvent");
var idlUtils = require("../generated/utils");
var _require = require("../helpers/events"),
  fireAnEvent = _require.fireAnEvent;

// https://html.spec.whatwg.org/multipage/webstorage.html#the-storage-interface
var StorageImpl = /*#__PURE__*/function (_idlUtils$supportedPr) {
  function StorageImpl(globalObject, args, privateData) {
    _classCallCheck(this, StorageImpl);
    var associatedWindow = privateData.associatedWindow,
      storageArea = privateData.storageArea,
      url = privateData.url,
      type = privateData.type,
      storageQuota = privateData.storageQuota;
    this._associatedWindow = associatedWindow;
    this._items = storageArea;
    this._url = url;
    this._type = type;
    this._quota = storageQuota;
    this._globalObject = globalObject;
  }
  _createClass(StorageImpl, [{
    key: "_dispatchStorageEvent",
    value: function _dispatchStorageEvent(key, oldValue, newValue) {
      var _this = this;
      return this._associatedWindow._currentOriginData.windowsInSameOrigin.filter(function (target) {
        return target !== _this._associatedWindow;
      }).forEach(function (target) {
        return fireAnEvent("storage", target, StorageEvent, {
          key: key,
          oldValue: oldValue,
          newValue: newValue,
          url: _this._url,
          storageArea: target["_" + _this._type]
        });
      });
    }
  }, {
    key: "length",
    get: function get() {
      return this._items.size;
    }
  }, {
    key: "key",
    value: function key(n) {
      if (n >= this._items.size) {
        return null;
      }
      return _toConsumableArray(this._items.keys())[n];
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      if (this._items.has(key)) {
        return this._items.get(key);
      }
      return null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var oldValue = this._items.get(key) || null;
      if (oldValue === value) {
        return;
      }

      // Concatenate all keys and values to measure their length against the quota
      var itemsTotalLength = key.length + value.length;
      var _iterator = _createForOfIteratorHelper(this._items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref = _step.value;
          var _ref2 = _slicedToArray(_ref, 2);
          var curKey = _ref2[0];
          var curValue = _ref2[1];
          // If the key already exists, skip it as it will be set to the new value instead
          if (key !== curKey) {
            itemsTotalLength += curKey.length + curValue.length;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (itemsTotalLength > this._quota) {
        throw DOMException.create(this._globalObject, ["The ".concat(this._quota, "-code unit storage quota has been exceeded."), "QuotaExceededError"]);
      }
      setTimeout(this._dispatchStorageEvent.bind(this), 0, key, oldValue, value);
      this._items.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this._items.has(key)) {
        setTimeout(this._dispatchStorageEvent.bind(this), 0, key, this._items.get(key), null);
        this._items["delete"](key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this._items.size > 0) {
        setTimeout(this._dispatchStorageEvent.bind(this), 0, null, null, null);
        this._items.clear();
      }
    }
  }, {
    key: _idlUtils$supportedPr,
    get: function get() {
      return this._items.keys();
    }
  }]);
  return StorageImpl;
}(idlUtils.supportedPropertyNames);
module.exports = {
  implementation: StorageImpl
};